import { Theme } from '../../models/system/theme';

/**
 * Theme "Blackhawk". Reference to setting in table dbo.Theme.
 * Note: Blackhawk skin defintion is incorrect. Color1 should be Color2.
 */
export const Theme_Vendor8031: Theme = {
  name: 'Vendor8031', // Same as value of field "Code" in table dbo.Theme.
  properties: {
    /* own color */
    '--mainColor': '#254578', // Color 2
    '--mainButtomColor': '#254578', // main Buttom
    '--minorColor': '#1636A1', // Color 3
    '--mainColorB':'#9e1f98',
    '--subColor': '#4E4E4E', // Color 1.
    '--mainBackgroundColor': '#F6F7F9', // Background
    '--mainTitleColor':'#2c3944',
    '--minorBackgroundColor': '#FFFFFF',
    '--importantLabel': '#333',
    '--ordinary_label': '#666',
    '--nonImportantLabel': '#999',
    '--dashColor1': '#abb5c4',
    '--dashColor2': '#000000',
    '--controlColor_span1': '#9e1f98',
    '--controlInptBackgroundColor1': '#f3f2f2',
    '--navTitleColor': '#FFFFFF',
    '--navTitleMinorColor': '#FFFFFF',

    '--extraPriceColor':'#287f3d;',    
    '--inTransitColor':'#0435c5',
    '--cartIconColor':'#FFFFFF',  
    '--grid_th_Color': '#F6F6F6',
    '--grid_td_Color': '#FFFFFF',

    /*hearder*/
    '--navbarBackground': '#FFFFFF',
    '--headerClickColor': '#254578',
    '--headerClickColor_border': '#254578',

    /*order*/
    '--grid_thColor': '#F6F6F6',
    '--controlColor_order_buttom1': '#FFDA0F',
    '--controlColor_order_buttom2': '#254578',
    '--controlColor_order_buttom3': '#090E22',
    '--controlColor_order_buttom4': '#254578',
    '--controlColor_buttomBorder1': '#FFDA0F',

    /*cart*/
    '--controlColor_buttom2': '#090E22',
    '--controlColor_buttom3': '#4E4E4E',
    '--controlColor_buttom2_font': '#FFFFFF',
    '--dialogBackgroundColor': '#FFFFFF',

    '--noFillColor':'#474747',
    '--disableCarat':"#ccc",

    /*Direct Container Order Grid */
    '--GridRightBorderTH': '#000000',
    '--GridRightBorderTD': '#CCC',
    '--GridHoverColorTR':'#CCC',
    '--TextOnHover': '#FFFFFF'
    /* Bootstrap css override */
  }
};
